import { render, staticRenderFns } from "./button-addtocart.vue?vue&type=template&id=731ec004"
import script from "./button-addtocart.vue?vue&type=script&lang=js"
export * from "./button-addtocart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports